import { useCallback, useState } from "react";
import { FormState, UserInterfaceState } from "../../../../shared/Enum";

import { LocationEntity } from "../../../../api/Locations/Entity/LocationEntity";
import { getLocationList } from "../../../../api/Locations/Repository";
import { FormEntity } from "../../../../api/Forms/Entity/FormEntity";
import {
  getFormDetail,
  getFormList,
  updateForm,
} from "../../../../api/Forms/Repository";
import { UpdateFormDto } from "../../../../api/Forms/Entity/UpdateFormDto";
import { enqueueSnackbar } from "notistack";

interface Return {
  data: {
    uiState: UserInterfaceState;
    formState: FormState;
    formDetail: FormEntity;
  };
  method: {
    onGetFormDetail(id: string): void;
    onUpdateForm(formData: UpdateFormDto): void;
  };
}

export default function useViewModel(): Return {
  const [uiState, setUiState] = useState<UserInterfaceState>(
    UserInterfaceState.Idle
  );
  const [formState, setFormState] = useState<FormState>(FormState.Idle);

  const [formDetail, setFormDetail] = useState<FormEntity>({
    id: "",
    imageName: "",
    imageUrl: "",
    isPublic: false,
    link: "",
    locationId: "",
    name: "",
    description: "",
  });

  const onGetFormDetail = useCallback(
    async (id: string) => {
      setUiState(UserInterfaceState.Loading);
      await getFormDetail(id)
        .then((res) => setFormDetail(res))
        .then(() => setUiState(UserInterfaceState.Success))
        .catch((error) => {
          console.log("Error fetching data:", error);
          setUiState(UserInterfaceState.Error);
        });
    },
    [getFormDetail]
  );

  const onUpdateForm = useCallback(
    async (formData: UpdateFormDto) => {
      setFormState(FormState.Loading);
      await updateForm(formData)
        .then(() => {
          setFormState(FormState.Success);
          enqueueSnackbar("Form updated successfully.", {
            variant: "success",
          });
        })
        .catch((error) => {
          console.log("Error updating data:", error);
          setFormState(FormState.Error);
        });
    },
    [updateForm]
  );

  return {
    data: {
      uiState,
      formState,
      formDetail,
    },
    method: { onGetFormDetail, onUpdateForm },
  };
}
